import { render } from "./TalkToMyDataInvocations.vue?vue&type=template&id=323e7bb6&scoped=true"
import script from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocations.vue?vue&type=style&index=0&id=323e7bb6&scoped=true&lang=css"
import "./TalkToMyDataInvocations.vue?vue&type=style&index=1&id=323e7bb6&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e7bb6"]])

export default __exports__